var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForum = function SvgForum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12.8 6.2A1.2 1.2 0 0 1 14 7.4v6.172a.426.426 0 0 1-.727.3l-1.321-1.32a1.2 1.2 0 0 0-.849-.352H6.8A1.2 1.2 0 0 1 5.6 11v-.6m4.8-3.6A1.2 1.2 0 0 1 9.2 8H4.897a1.2 1.2 0 0 0-.849.351l-1.32 1.322A.426.426 0 0 1 2 9.37V3.2A1.2 1.2 0 0 1 3.2 2h6a1.2 1.2 0 0 1 1.2 1.2z"
  })));
};
export default SvgForum;